import React, { createContext, useContext, useState, useEffect } from 'react';
import { AgeBand } from './dataExperienceContext';
import useExperienceData from '../hooks/useExperienceData';

export type TravelersState = Partial<Record<AgeBand, number>>;

type TravelersContextType = {
  travelers: TravelersState;
  setTravelers: (travelers: TravelersState) => void;
  selectedDate: string;
  setSelectedDate: (date: string) => void;
  selectedItemCode: string | null;
  setSelectedItemCode: (code: string | null) => void;
};

const TravelersContext = createContext<TravelersContextType | undefined>(undefined);

export const TravelersProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [travelers, setTravelers] = useState<TravelersState>({});
  const [selectedDate, setSelectedDate] = useState<string>('');
  const [selectedItemCode, setSelectedItemCode] = useState<string | null>(null);
  const { experience } = useExperienceData();

  useEffect(() => {
    if (!experience?.product?.pricingInfo?.ageBands) return;

    const initialState: TravelersState = {};
    experience.product.pricingInfo.ageBands.forEach(band => {
      if (band.ageBand) {
        if(band.ageBand === 'ADULT'){
          const { requiresAdultForBooking, maxTravelersPerBooking} = experience.product.bookingRequirements;
          if(requiresAdultForBooking) {
            initialState[band.ageBand] = 1;
          } else if(maxTravelersPerBooking >= 2) {
            initialState[band.ageBand] = 2;
          }
        } else {
          initialState[band.ageBand] = 0;
        }
      }
    });
    setTravelers(initialState);
  }, [experience]);

  return (
    <TravelersContext.Provider value={{ 
      travelers, 
      setTravelers,
      selectedDate,
      setSelectedDate,
      selectedItemCode,
      setSelectedItemCode,
    }}>
      {children}
    </TravelersContext.Provider>
  );
};

export const useTravelers = () => {
  const context = useContext(TravelersContext);
  if (!context) {
    throw new Error('useTravelers must be used within a TravelersProvider');
  }
  return context;
}; 